import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatCardModule} from '@angular/material/card';
import {TranslateModule} from '@ngx-translate/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatTableModule} from '@angular/material/table';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {FlexModule} from '@angular/flex-layout';
import {MatPaginatorModule} from '@angular/material/paginator';
import {SharedModule} from '../shared/shared.module';
import {MatTooltipModule} from '@angular/material/tooltip';
import {SettingsManagementComponent} from './setting-management/settings-management.component';
import {SettingsRoutingModule} from './settings-routing.module';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { LibraryConfigComponent } from './library-config/library-config.component';


@NgModule({
  declarations: [SettingsManagementComponent, LibraryConfigComponent],
  imports: [
    CommonModule,
    SettingsRoutingModule,
    MatCardModule,
    TranslateModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatProgressSpinnerModule,
    FlexModule,
    MatPaginatorModule,
    SharedModule,
    MatTooltipModule,
    MatAutocompleteModule,
    TranslateModule.forChild({
      extend: true
    })
  ]
})
export class SettingsModule {
}
